import React, { useEffect, useState, useRef } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
    faEye,
    faFileAlt,
    faPrint
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP, DEFAULT_SUMMARY_MESSAGE } from '../../../constants'
import moment from "moment";
import { convertOrderStatus } from "../../../helpers/orderStatus";
import { thousandSeperate } from "../../../helpers";
import { GET_ORDERS } from "../../../graphql/order/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import ReactToPrint from "react-to-print";
import OrderBillWithName from "./orderBillWithName";

import { UPDATE_ORDER } from "../../../graphql/order/mutation";
import LiveDetailMessenger from "./PostDetailMessenger";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import WhatsappIcon from "../../../components/WhatsappIcon";
import { GET_POST_STOCKS } from "../../../graphql/postStock/query";

function PostDetailCF({ peopleOrders, liveData }) {
    const { history } = useReactRouter()

    const [liveOrderList, setLiveOrderList] = useState([]);
    const [liveTotalOrderList, setLiveTotalOrderList] = useState([]);
    const [liveStockList, setLiveStockList] = useState([]);
    const [liveProductSummary, setLiveProductSummary] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [orderToPrint, setOrderToPrint] = useState([])
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [selectedUser, setSelectedUser] = useState();
    const [showUserModal, setShowUserModal] = useState(false)
    const [showMessengerModal, setShowMessengerModal] = useState(false)
    const [userPhone, setUserPhone] = useState("85620")
    const [message, setMessage] = useState(DEFAULT_SUMMARY_MESSAGE);
    const [shopSettings, setShopSettings] = useState([]);

    const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    // const [getLiveStockData, { data: liveStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });
    const [updateOrder] = useMutation(UPDATE_ORDER);
    const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

    let componentRef = useRef()

    useEffect(() => {
        // if (liveData) getLiveOrder()
        initSetting()
    }, [liveData])

    useEffect(() => {
        editPostDetailList(peopleOrders);
    }, [peopleOrders])

    useEffect(() => {
        if (liveOrderList && liveStockList) {
            modifyData()
        }
    }, [liveOrderList, liveStockList])

    // useEffect(() => {
    //     if (orderData?.orders?.data) {
    //         // console.log("orderData: ", orderData?.orders?.data)
    //         let _liveTotalOrderList = []
    //         const _data = _.groupBy(orderData?.orders?.data, "cfName")
    //         // let _orderToPrint = []
    //         for (let [cfName, value] of Object.entries(_data)) {
    //             var _price = 0
    //             var _count = 0
    //             var _stockCfMessages = ''
    //             var _createdAt = ''
    //             var _status = ''
    //             var _pageName = ''
    //             var _phone = ''
    //             var _pageId = ''
    //             for (var i = 0; i < value.length; i++) {
    //                 _price += (value[i].totalPrice ?? value[i].price)
    //                 _count += (value[i].amount ?? 1)
    //                 _stockCfMessages = _stockCfMessages + (_stockCfMessages != '' ? ', ' : '') + value[i]?.postStock?.cfMessage
    //                 _createdAt = value[0].createdAt
    //                 _status = value[0].status
    //                 _pageName = value[0].post.pageName
    //                 _pageId = value[0].post.page
    //                 _phone = value[0].phone
    //             }
    //             _liveTotalOrderList.push({
    //                 cfName: cfName,
    //                 totalPrice: _price,
    //                 totalCount: _count,
    //                 stockMessages: _stockCfMessages,
    //                 createdAt: _createdAt,
    //                 status: _status,
    //                 orders: value,
    //                 pageName: _pageName,
    //                 pageId: _pageId,
    //                 phone: _phone
    //             })
    //             // _orderToPrint.push({
    //             //     pageName: _pageName,
    //             //     cfName: cfName,
    //             //     totalPrice: _price,
    //             //     createdAt: _createdAt,
    //             // })
    //         }
    //         // setOrderToPrint(_orderToPrint)

    //         // console.log(_liveTotalOrderList)
    //         setLiveTotalOrderList(_liveTotalOrderList)
    //         setLiveOrderList(orderData.orders.data)
    //         setIsLoading(false)
    //     }
    // }, [orderData])

    // console.log("liveTotalOrderList",liveTotalOrderList)

    // useEffect(() => {
    //     if (liveStockData) {
    //         setLiveStockList(liveStockData.postStocks.data)
    //     }
    // }, [liveStockData])

    useEffect(() => {
        if (shopSettingData && shopSettingData?.settings?.data?.length > 0) {
            setShopSettings(shopSettingData?.settings?.data[0])
        }
    }, [shopSettingData])

    useEffect(() => {
        editPostDetailList(Object.values(_.groupBy(orderData?.orders?.data, 'cfName')))
    }, [orderData])

    const editPostDetailList = (orderDataGroupList) => {
        let _newPeopleOrders = orderDataGroupList.map((people) => {
            return {
                cfName: people[0]?.cfName,
                totalPrice: people?.reduce((sumPrice, order) => {
                    return sumPrice + (order?.amount * order?.price)
                }, 0),
                totalCount: people?.reduce((sumAmount, order) => {
                    return sumAmount + order?.amount
                }, 0),
                stockMessages: people?.map((message) => { return message?.cfMessage }).join(', '),
                createdAt: people[0]?.createdAt,
                status: people[0]?.status,
                code: people[0]?.code,
                // orders: value,
                pageName: liveData?.pageName,
                pageId: liveData?.pageId,
                phone: people[0]?.phone
            }
        });
        setLiveTotalOrderList(_newPeopleOrders)
    }

    // const getLiveOrder = async () => {
    //     try {
    //         setIsLoading(true)
    //         await getOrderData({
    //             variables: {
    //                 where: {
    //                     post: liveData?.id,
    //                     isDeleted: false
    //                 },
    //                 skip: 0,
    //                 limit: 1000
    //             }
    //         })
    //         await getLiveStockData({
    //             variables: {
    //                 where: {
    //                     post: liveData?.id,
    //                     isDeleted: false
    //                 },
    //                 skip: 0,
    //                 limit: 1000
    //             }
    //         })
    //     } catch (error) {
    //         console.log("Error retrieving posts", error);
    //     }
    // }

    const initSetting = async () => {
        setIsLoading(true)
        let SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID
                },
                orderBy: "createdAt_ASC"
            }
        })
        setIsLoading(false)
    }

    const modifyData = async () => {
        const result = _.groupBy(liveOrderList, 'postStock.id')

        let _liveProductSummary = []
        for (let [key, value] of Object.entries(result)) {
            let _mapStock = liveStockList.filter((lStock) => lStock.id == value[0]?.postStock?.id)
            let pushData = {
                ..._mapStock[0],
                count: value.length,
                cfMessage: value[0]?.postStock?.cfMessage
            }
            _liveProductSummary.push(pushData)
        }
        setLiveProductSummary(_liveProductSummary)
        setIsLoading(false)
    }


    const goToUserOrder = async (data) => {
        history.push('/post-user-detail', data)
    }

    const onSeletedAllOrder = async () => {
        if (isSelectAll) {
            setOrderToPrint([])
            setIsSelectAll(false)
        } else {
            // const _data = _.groupBy(liveOrderList, "cfName")
            // let _orderToPrint = []
            // for (let [cfName, value] of Object.entries(_data)) {
            //     var _price = 0
            //     var _createdAt = ''
            //     var _pageName = ''
            //     for (var i = 0; i < value.length; i++) {
            //         _price += (value[i].totalPrice ?? value[i].price)
            //         _createdAt = value[0].createdAt
            //         _pageName = value[0].post.pageName
            //     }
            //     _orderToPrint.push({
            //         pageName: _pageName,
            //         cfName: cfName,
            //         totalPrice: _price,
            //         createdAt: _createdAt,
            //     })
            // }
            setOrderToPrint(liveTotalOrderList)
            setIsSelectAll(true)
        }
    }

    const onSelectOrder = (data) => {
        var _newOrderToPrint = orderToPrint;
        // console.log('data: ', data)

        if (orderToPrint.length <= 0) {
            return _newOrderToPrint.push(data);
        }
        orderToPrint.map((order) => {
            // console.log('order: ', data)
            if (order.cfName === data.cfName) {
                return _newOrderToPrint.pop({ cfName: order.cfName });
            }
            return _newOrderToPrint.push(data);
        });
        // console.log('_newOrderToPrint: ', _newOrderToPrint)
        // setOrderToPrint(_newOrderToPrint)
        // if (orderToPrint && orderToPrint.length > 0) {
        //     let _checkOrder = orderToPrint.filter(item => item.cfName == data.cfName)
        //     if (_checkOrder && _checkOrder.length > 0) {
        //         let _checkOrder2 = orderToPrint.filter(item => item.cfName != data.cfName)
        //         setOrderToPrint(_checkOrder2)
        //     } else {
        //         let _orderToPrint = [...orderToPrint]
        //         let _totalPrice = 0
        //         for (var i = 0; i < data?.orders.length; i++) {
        //             _totalPrice += (data?.orders[i].totalPrice ?? data?.orders[i].price)
        //         }
        //         _orderToPrint.push({
        //             pageName: data.orders[0].post.pageName,
        //             cfName: data.cfName,
        //             totalPrice: data.totalPrice,
        //             createdAt: data.createdAt,
        //         })
        //         setOrderToPrint(_orderToPrint)
        //     }
        // } else {
        //     let _orderToPrint = []
        //     let _totalPrice = 0
        //     for (var i = 0; i < data?.orders.length; i++) {
        //         _totalPrice += (data?.orders[i].totalPrice ?? data?.orders[i].price)
        //     }
        //     _orderToPrint.push({
        //         pageName: data.orders[0].post.pageName,
        //         cfName: data.cfName,
        //         totalPrice: (data.totalPrice ?? data.price),
        //         createdAt: data.createdAt,
        //     })
        //     setOrderToPrint(_orderToPrint)
        // }
    }

    const _selectListLiveWithStatus = async (value) => {
        try {
            if (value) {
                await getOrderData({
                    variables: {
                        where: {
                            cfName: value,
                            post: liveData?.id,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 1000
                    }
                })
            } else {
                await getOrderData({
                    variables: {
                        where: {
                            post: liveData?.id,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 1000
                    }
                })
            }

        } catch (error) {
            console.log("Error retrieving posts", error);
        }
    }


    const _updateUserPhone = async (_selectedUser) => {
        try {

            let _afterUpdate = await updateOrder({
                variables: {
                    where: {
                        id: _selectedUser?.orders[0]?.id
                    },
                    data: {
                        phone: userPhone
                    }
                }
            })
            // console.log("OK!")
            // if (_selectedUser) {
            //     let _liveTotalOrderList = [...liveTotalOrderList]
            //     let _updateTotalLive = _liveTotalOrderList.map((liveTotal) => {
            //         if (_selectedUser.order[0].id == liveTotal.order[0].id) {
            //             liveTotal.phone = userPhone
            //         }
            //         return liveTotal;
            //     })

            //     setLiveTotalOrderList(_updateTotalLive)
            // }

            // if (isNaN(userPhone)) {
            //     return
            // }

            let cfText
            let total = 0
            selectedUser.orders.map((cf, index) => {
                cfText = (cfText ? cfText : "") + (index + 1) + " : " + cf.productName + " ( x" + cf.amount + " ) :  " + new Intl.NumberFormat('en-US').format(cf.totalPrice ?? cf.price) + ` ກີບ \n`
                total = total + (cf.totalPrice ?? cf.price)
            })
            let settingMessage = message;
            var _variableList = settingMessage.match(/\{\{.+?\}\}/g)
            let _bankData = (shopSettings && shopSettings.bank) ? JSON.parse(shopSettings.bank) : ""
            if (_variableList && _variableList.length > 0) _variableList.map((x, index) => {
                if (x.includes("cfText")) settingMessage = settingMessage.replace(x, cfText);
                if (x.includes("total")) settingMessage = settingMessage.replace(x, new Intl.NumberFormat('en-US').format(total));
                if (x.includes("bankName")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankName) ? _bankData.bankName : "");
                if (x.includes("bankAccount")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankAccount) ? _bankData.bankAccount : "");
                if (x.includes("bankUser")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankUser) ? _bankData.bankUser : "");
            })

            let _userPhone = userPhone
            setUserPhone("")
            setShowUserModal(false)
            // console.log(`https://wa.me/${_userPhone}?text=${settingMessage}`)
            window.open(`https://wa.me/${_userPhone}?text=${settingMessage}`)

        } catch (err) {
            setShowUserModal(false)
        }


    }

    return (
        <div>
            <div style={{ height: 10 }} />
            <div className="row" style={{ margin: 0 }}>
                <div >
                    <input type="text" className="form-control" placeholder="ຄົ້ນຫາຕາມຊື່ລູກຄ້າ . . . . ." onChange={(e) => _selectListLiveWithStatus(e.target.value)}></input>
                </div>
                {/* <div className="col-3 d-flex justify-content-center align-items-center" style={{ background: "green", color: "#fff" }}>
                    <FontAwesomeIcon icon={faFileAlt} />
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-app hoverme text-white"
                        table="table-to-xls"
                        filename={"Orders-live-detail-" + (new Date().toISOString())}
                        sheet="Orders"
                        buttonText="ດາວໂຫຼດເອັກເຊວ"
                    />
                </div>
                <div style={{ width: 20 }} />
                <ReactToPrint
                    trigger={() => <button className="btn btn-app hoverme col-3"
                        style={{ background: COLOR_APP, color: "#fff" }}
                    >
                        <FontAwesomeIcon icon={faPrint} style={{ marginRight: 6 }} /> Print
                    </button>}
                    content={() => componentRef.current}
                /> */}
            </div>
            {/* <div style={{ display: 'none' }}>
                <OrderBillWithName ref={componentRef} data={orderToPrint} senderInfo={liveData} />
            </div> */}
            <div style={{ height: 10 }} />
            {/* {isLoading &&
                <div className="col-12" style={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="spinner-border" style={{ color: COLOR_APP }} role="status" />
                </div>
            } */}
            {liveTotalOrderList?.length > 0 ? <Table responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr style={{ whiteSpace: 'nowrap' }}>
                        {/* <th style={{ borderBottom: "none" }}><Form.Check type="checkbox" onClick={() => onSeletedAllOrder()} /></th> */}
                        <th style={{ borderBottom: "none" }}>ລຳດັບ</th>
                        <th style={{ borderBottom: "none" }}>ຜູ້ສັ່ງ</th>
                        {/* <th>ເບີໂທ</th> */}
                        <th style={{ borderBottom: "none" }}>ຈຳນວນ</th>
                        <th style={{ borderBottom: "none" }}>ລະຫັດສິນຄ້າ</th>
                        <th style={{ borderBottom: "none" }}>ລວມເງິນ</th>
                        <th style={{ borderBottom: "none" }}>ເວລາ</th>
                        <th style={{ borderBottom: "none" }}>ສະຖານະ</th>
                        <th style={{ borderBottom: "none" }}>ການສ້າງອໍເດີ</th>
                        {/* <th style={{ borderBottom: "none" }}>ຈັດການ</th> */}
                    </tr>
                </thead>
                <tbody>
                    {liveTotalOrderList?.map((order, index) => (
                        <tr key={index} onClick={() => {
                            setSelectedUser(order)
                            // setUserPhone(order.phone)
                        }}>
                            {/* <td>
                                {isSelectAll ?
                                    <Form.Check
                                        type="checkbox"
                                        checked={true}
                                        disabled
                                    />
                                    :
                                    <Form.Check
                                        type="checkbox"
                                        onClick={() => onSelectOrder(order)}
                                    />}
                            </td> */}
                            <td>{index + 1}</td>
                            <td>{order?.cfName}</td>
                            {/* <td><div onClick={() => {
                                    setUserPhone(order?.phone)
                                    setShowUserModal(true)
                                }} style={{ background: COLOR_APP, color: "#fff", padding: 3, borderRadius: 12, cursor: "pointer" }} className="text-center">{order.phone || "-"}</div></td> */}
                            <td>{thousandSeperate(order?.totalCount ?? 1)}</td>
                            <td style={{ wordBreak: "break-word", width: 160 }}>{order?.stockMessages}</td>
                            <td>{thousandSeperate(order?.totalPrice ?? 0)}</td>
                            <td>{moment(order?.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>{convertOrderStatus(order?.status)}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                                {order?.code?.startsWith("ORDER") ? (
                                    <span style={{
                                        background: '#fff3cd',
                                        color: '#856404',
                                        padding: '2px 8px',
                                        borderRadius: 12,
                                        fontSize: 12,
                                        display: 'inline-block'
                                    }}>
                                        ອໍເດີສ້າງເອງ
                                    </span>
                                ) : (
                                    <span style={{
                                        background: '#d4edda',
                                        color: '#155724',
                                        padding: '2px 8px',
                                        borderRadius: 12,
                                        fontSize: 12,
                                        display: 'inline-block'
                                    }}>
                                        ລະບົບດູດ
                                    </span>
                                )}
                            </td>
                            {/* <td >
                                <div className="row" style={{ margin: 0, display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                    <div style={{ width: 40, cursor: "pointer" }} onClick={() => {
                                        goToUserOrder(order)
                                    }}>
                                        <FontAwesomeIcon icon={faEye} style={{ color: COLOR_APP }} />
                                    </div>
                                    <div style={{ width: 40, cursor: "pointer" }} onClick={() => {
                                        setUserPhone(order?.phone)
                                        setShowUserModal(true)
                                    }}>
                                        <WhatsappIcon style={{ color: "#25D366", fontSize: 20 }} />
                                    </div> */}
                            {/* <div style={{ width: 40, cursor: "pointer" }} onClick={() => {
                                            setShowMessengerModal(true)
                                        }}>
                                            <MEssengerIcon style={{ color: "#1877f2", fontSize: 20 }} />
                                        </div> */}
                            {/* </div>
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </Table> :
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img height={130} width={140} src={'images/no_data.png'} />
                    <h5>ບໍ່ມີອໍເດີ້ເທຶ່ອເດີ!</h5>
                </div>}

            {/* {
                liveOrderList.length > 0 && <Table id="table-to-xls" style={{ display: "none" }} responsive className="staff-table-list borderless table-hover">
                    <thead style={{ background: "#F1F1F1" }}>
                        <tr>
                            <th>ລຳດັບ</th>
                            <th>ຜູ້ສັ່ງ</th>
                            <th>ສິນຄ້າ</th>
                            <th>ຂະຫນາດ</th>
                            <th>ລາຄາ</th>
                            <th>ລວມເປັນເງິນ</th>
                            <th>ຂໍ້ຄວາມ</th>
                            <th>ເວລາ</th>
                            <th>ສະຖານະ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveOrderList &&
                            liveOrderList?.map((order, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{order?.cfName}</td>
                                    <td>{order?.productName}</td>
                                    <td>{order?.amount ?? 1}</td>
                                    <td>{(order?.price ?? 0)}</td>
                                    <td>{order?.totalPrice ?? 0}</td>
                                    <td>{order?.message}</td>
                                    <td>{moment(order?.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                                    <td>{convertOrderStatus(order?.status)}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            } */}

            <Modal show={showUserModal} onHide={() => setShowUserModal(false)}>
                <Modal.Header closeButton>
                    <div style={{ textAlign: "center" }}>
                        <div>ເພີ່ມເບີ Whatsapp ລູກຄ້າເພື່ອຕິດຕໍ່ຜ່ານທາງວ໊ອບແອັບ </div>
                        <div style={{ color: "red" }}></div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: "center" }}>
                        <div>ລູກຄ້າ: {selectedUser?.cfName} </div>
                        <div style={{ color: "red" }}></div>
                    </div>
                    <Form.Group controlId="exampleForm.ControlInput1">
                        {/* <Form.Label>ເບີໂທລູກຄ້າ:{selectedUser?.phone} </Form.Label> */}
                        <Form.Control
                            type="text"
                            onChange={(e) => setUserPhone(e.target.value)}
                            value={userPhone}
                            placeholder="ເບີ whatsapp ລູກຄ້າ..." />
                    </Form.Group>
                    <div style={{ color: "#aaaaaa" }}>ໝາຍເຫດ: ເບີ Whatsapp ຕ້ອງຕື່ມລະຫັດປະເທດ ແລະ ລະຫັດເຂດກ່ອນຕາມດ້ວຍເບີໂທ 8 ໂຕ (ຕົວຢ່າງ: 8562099887766)</div>
                    <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Control
                            as="textarea" rows={15}
                            placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຕ້ອງການຈະສົ່ງຫາລູກຄ້າ..."
                            value={message || ""}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUserModal(false)}>
                        ຍົກເລີກ
                    </Button>
                    <Button style={{ background: COLOR_APP, color: "#ffff", border: 0 }}
                        onClick={async () => _updateUserPhone(selectedUser)}>
                        ບັນທຶກ ແລະ ສົ່ງ
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showMessengerModal} onHide={() => setShowMessengerModal(false)}>
                <Modal.Header closeButton>
                    <div style={{ textAlign: "center" }}>
                        <div>ຕິດຕໍ່ຫາລູກຄ້າຜ່ານທ່າງ Facebook Messenger </div>
                        <div style={{ color: "red" }}></div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <LiveDetailMessenger selectedUserOrder={selectedUser} closeMessengerModal={() => setShowMessengerModal(false)} />
                </Modal.Body>
            </Modal>

        </div >
    );
}

export default PostDetailCF;
